import { useSearchParams } from 'react-router-dom';
import { debounce } from 'lodash';
import { Icon } from '@mui/material';

import './Searchbar.scss';

// TODO debounce search (recommend lodash) and connect to backend
const Searchbar = () => {
	const [searchParams, setSearchParams] = useSearchParams({
		q: ''
	});
	const q = searchParams.get('q');

	const valueChangeHandler = debounce((val) => {
		setSearchParams(
			(prev) => {
				prev.set('q', val);
				return prev;
			},
			{ replace: true }
		);
	}, 1000);

	return (
		<div className='searchbar-container'>
			<Icon className='searchbar-icon'>search</Icon>
			<input
				className='searchbar-input'
				placeholder='Search your study name'
				type='text'
				onChange={(e) => valueChangeHandler(e.target.value)}
			/>
		</div>
	);
};
export default Searchbar;
